import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { ClientService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { ClientGender, ClientRelation, ClientStatus } from '@fitness-force/enum';
import { ClientById, Country, STAFFINTERFACE, STAGE_MASTER_MODEL } from '@fitness-force/models';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { ChangeSalesRepresentativeComponent, ClientHistoryComponent, DayAgoPipe, timeLineService } from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TENANTS_INFO, STAGE_MASTER_STATE, COUNTRY_MASTER_STATE_LIST } from 'apps/ff-frontend/src/app/state/app.state';
import { BadgeModule } from 'primeng/badge';
import { MessageModule } from 'primeng/message';

import { PopoverModule } from 'primeng/popover';
import { SkeletonModule } from 'primeng/skeleton';
import { BehaviorSubject, Observable, combineLatest, map, of } from 'rxjs';
import Statsig from 'statsig-js';
import { ClientCreditBalanceComponent } from '../client-credit-balance/client-credit-balance.component';
import { AvatarModule } from 'primeng/avatar';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CountryISO, NgxIntlTelInputComponent, PhoneNumberFormat } from '@fitness-force/fitness-int-phone-code';
import * as lpn from 'google-libphonenumber';
import { StaffStoreService } from 'libs/api/src/lib/staff/staff-store.service';

@Component({
  selector: 'client-profile-details-tab',
  templateUrl: './client-profile-details-tab.component.html',
  styleUrls: ['./client-profile-details-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    SkeletonModule,
    PopoverModule,
    CurrencyformatPipe,
    DateTimeFormatPipe,
    ClientCreditBalanceComponent,
    MessageModule,
    BadgeModule,
    AvatarModule,
    DayAgoPipe,
    ChangeSalesRepresentativeComponent,
    FormsModule,
    ToggleSwitchModule,
    SelectModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    ReactiveFormsModule,
    NgxIntlTelInputComponent,
    ClientHistoryComponent,
    TranslateModule],
})
export class ClientProfileDetailsTabComponent implements OnInit {
  @Input('clientDetails') client: ClientById = {} as ClientById;
  @Input('tenantId') tenantId = 0;
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);

  currentTenantId = 0;
  showClientDetails: boolean = false;
  showClientSidebar: boolean = false;
  allClients$ = new BehaviorSubject<ClientById>({} as ClientById);
  selectedMenu: any;
  getAccessTenantList$: Observable<any> | any | null;
  allTenants: any = [];
  selectedTenant: any;
  allStaffs: any = [];
  clientIds: number[] = [];
  showOrganization = false;
  showAddCreditButton: boolean = false;

  toggleSendEmailDialog$: any = new BehaviorSubject<boolean>(false);
  toggleCreateSmsDialog$: any = new BehaviorSubject<boolean>(false);
  isBlackListed = new BehaviorSubject<boolean>(false);
  currentTenantClient: boolean = true;

  toggleChangeSaleRepDialog$ = new BehaviorSubject<boolean>(false);
  toggleEditProfileDialog$ = new BehaviorSubject<boolean | null>(false);
  showBookAppointmentPopup: boolean = false;
  attachmentsModal:boolean =false;
  showCreditBalance:boolean=false;

  changeMobile: boolean = false;
  changeEmail: boolean = false;
  changeDOB: boolean = false;
  changeGender: boolean = false;
  changeEmergencyContact: boolean = false;
  changeAddress: boolean = false;
  changeSalesRep: boolean = false;
  changeChannel: boolean = false;
  changeSource: boolean = false;

  EnumGender = Object.entries(ClientGender).filter((key) => typeof key[1] != 'number').map(([key, value]) => ({ key, value }));
  ClientRelation = Object.entries(ClientRelation)
  .filter((key) => typeof key[1] != 'number')
  .map(([key, value]) => ({ key, value }));
  
  channelCollection: any[] = CONSTANTS_DATA.CHANNEL_SOURCES;
  updateClientFormGroup: FormGroup = new FormGroup({});
  isClientRepresentative = new BehaviorSubject(true);
  claims : Observable<string[]> = of(['can_be_client_rep']);
  Source: string[] = [];
  salesRep: any[] = [];
  onlyCountries: CountryISO[] = [];
  tenantCountry: any;
  PhoneNumberFormat = PhoneNumberFormat;
  canEditDetails: boolean = false;
  clientMobileNoCountry: string='';
  countries: Country[] = [];
  phoneUtil: any = lpn.PhoneNumberUtil.getInstance();
  showClientHistory: boolean = false;


  constructor(
    private fb: FormBuilder,
    private clientService: ClientService,
    private store: Store,
    private timeService: TimeconversionService,
    private cd: ChangeDetectorRef,
    private toastMessageService: ToastMessageService,
    private translate: TranslateService,
    private staffStoreService: StaffStoreService
  ) {
    this.initializeForm();
    combineLatest([this.store.select(TENANTS_INFO), this.store.select(COUNTRY_MASTER_STATE_LIST)]).subscribe(([tenant, country]) => {
      this.currentTenantId = tenant.selected_tenant.id;
      this.allTenants = tenant.all_tenant;
      this.selectedTenant = tenant.selected_tenant;
      this.countries = country;
    });

     this.staffStoreService.getAllStaff(this.tenantId).subscribe((staff) => {
      this.allStaffs = staff;
      this.salesRep = this.allStaffs.filter((s:STAFFINTERFACE) => String(s.status).toLowerCase() == 'active' && s.can_be_client_rep);
    });
  }

  ngOnInit(): void {
    if (Statsig.checkGate("client_organisation_link")) {
      this.showOrganization = true;
    }
    
    if (Statsig.checkGate("show_refund")) {
      this.showAddCreditButton = true;
    }

    this.setTenantCountry();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['client'] && changes['client'].currentValue != changes['client'].previousValue) {
      this.initializeFormValues();
    }
  }

  initializeForm() {
    this.updateClientFormGroup = this.fb.group({
      marketing_preferences: this.fb.group({
        email: [false],
        sms: [false],
        whatsapp: [false],
        phone: [false]
      }),
      // Add other client fields here
      mobile_number: [''],
      email_id: ['',[ Validators.email, Validators.required]],
      date_of_birth: [''],
      emergency_contact_person: [''],
      emergency_contact_number: [''],
      gender: [''],
      channel: [''],
      source: [''],
      address: [''],
      salesRep: ['']
    });
  }

  initializeFormValues() {
    if (this.client) {
      // Initialize marketing preferences
      const marketingPrefs = {
        email: this.client.promotional_notification_channels_allowed?.includes('Email'),
        sms: this.client.promotional_notification_channels_allowed?.includes('SMS'),
        whatsapp: this.client.promotional_notification_channels_allowed?.includes('WhatsApp'),
        phone: this.client.promotional_notification_channels_allowed?.includes('Phone')
      };

      this.Source = this.channelCollection.find(c => c.channel == this.client.channel)?.source;
      this.updateClientFormGroup.patchValue({
        marketing_preferences: marketingPrefs,
        mobile_number: this.client.mobile_number,
        email_id: this.client.email_id,
        date_of_birth: this.isDefaultDate(this.client.date_of_birth) ? null : this.timeService.ConvertUTCToLocalDateTime(this.client.date_of_birth),
        emergency_contact_person: this.client.emergency_contact_person,
        emergency_contact_number: this.client.emergency_contact_number,
        gender: this.EnumGender.find(g => g.value == this.client.gender),
        channel: this.channelCollection.find(c => c.channel == this.client.channel),
        source: this.Source.find(s => s == this.client.source),
        address: this.client.address,
        salesRep: this.allStaffs.find((s:STAFFINTERFACE) => s.id == this.client.client_representative_id)
      });

      if(!this.isCurrentTenantClient)
      {
        this.updateClientFormGroup.get('marketing_preferences')?.disable();
      }
      this.updateClientFormGroup.updateValueAndValidity();
      this.cd.detectChanges();
      if(this.client.mobile_country_code)
        this.clientMobileNoCountry = this.countries.find(o => o.dial_code.replace(/\D/g, "") == this.client.mobile_country_code.replace(/\D/g, ""))!.two_letter_code.toLowerCase();
    }
  }

  onMarketingPreferenceChange() {
    const marketingPrefs = this.updateClientFormGroup.get('marketing_preferences')?.value;
    const updatedPreferences = Object.keys(marketingPrefs)
      .filter(key => marketingPrefs[key]);

    let clientObj: Array<{ op: string, path: string, value: any }> = [];
    clientObj.push({ op: "replace", path: "/PromotionalNotificationChannelsAllowed", value: updatedPreferences });

    this.clientService.patchClient(this.client.id, this.tenantId, clientObj).subscribe({
      next: (response) => {
        this.client.promotional_notification_channels_allowed = updatedPreferences;
        this.toastMessageService.showSuccess(this.translate.instant('CLIENT_PROFILE.SUCCESS_MESSAGES.MARKETING_PREFERENCES_UPDATED'));
        this.cd.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.initializeFormValues();
        this.cd.detectChanges();
      }
    });
  }

  getClientDetails() {
    this.showSkeleton$.next(true);
    this.clientService.getClientByIdNew(this.client.id).subscribe({
      next: (res: ClientById) => {
        this.client = res;
        this.allClients$.next(this.client);
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      }
    });
  }

  setTenantCountry() {
    combineLatest([this.store.select(TENANTS_INFO), this.store.select(COUNTRY_MASTER_STATE_LIST)]).subscribe(([tenant, country]) => {
      this.tenantId= tenant.selected_tenant.id;
      var countries = country;
      if (countries.length > 0) {
        this.tenantCountry = countries.find(o => o.three_letter_code.toLowerCase() == tenant.selected_tenant.country.toLowerCase())!.two_letter_code.toLowerCase();
        for (let [key, value] of Object.entries(CountryISO)) {
            this.onlyCountries.push(<CountryISO>value)
          }
          this.cd.detectChanges();
        }
      else {
        throw new Error('Country Not Found');
      }
    })
  }

  get isCurrentTenantClient() {
    if (this.client && (this.client.client_status == ClientStatus.Client || this.client.client_status.toString() == ClientStatus[ClientStatus.Client])) {
      if (this.currentTenantId == this.client.home_club_tenant_id) this.currentTenantClient = true;
      else this.currentTenantClient = false;
    }
    else if (this.client && (this.client.client_status == ClientStatus.Prospect || this.client.client_status.toString() == ClientStatus[ClientStatus.Prospect])) {
      if (this.currentTenantId == this.client.latest_createdin_tenant_id) this.currentTenantClient = true;
      else this.currentTenantClient = false;
    }
    else {
      if (this.client && (this.currentTenantId == this.client.latest_createdin_tenant_id && this.currentTenantId == this.client.home_club_tenant_id)) this.currentTenantClient = true;
      else if (this.client && (this.currentTenantId == this.client.home_club_tenant_id)) this.currentTenantClient = true;
      else {
       if(this.client) this.currentTenantClient = false;
      }
    }
    return this.currentTenantClient;
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(client.client_status.toString());
    else
      return '';
  }

  memberSince(fromDate: string) {
    return timeLineService(this.timeService.ConvertUTCToLocalDateTime(fromDate));
  }

  getStageStatus(): Observable<string> {
    let stageMaster = this.client.stage_master.find(s => s.tenant_id == this.currentTenantId);
    return this.store.select(STAGE_MASTER_STATE).pipe(
      map((value: STAGE_MASTER_MODEL[]) => value.find(obj => obj.id == stageMaster?.stage_master_id)?.name_primary_language!)
    );
  }

  isDefaultDate(date: string): boolean {
    let year = new Date(date).getFullYear();
    if (year == 9999 || year == 1 || date == null) return true;
    else return false;
  }

  isDefaultBirthDayDate(date: string): boolean {
    if(date  == null) return true;
    let year = new Date(date).getFullYear();
    if (year == 9999 || year == 1) return true;
    else return false;
  }

  isProspect(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.Prospect || status.toString() == ClientStatus[ClientStatus.Prospect]
  }

  isNonMember(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.ClientNonMember || status.toString() == ClientStatus[ClientStatus.ClientNonMember]
  }

  isExClientNonMember(status: any): Boolean {
    let cltStatus = ClientStatus[status as keyof typeof ClientStatus];
    return cltStatus == ClientStatus.ExClientNonMember || status.toString() == ClientStatus[ClientStatus.ExClientNonMember]
  }


  crownType(clientSince: string) {
    const ValidDate = new Date(this.timeService.ConvertUTCToLocalDateTime(clientSince));
    if (isNaN(ValidDate.getDate())) {
      return { crown: 'silver-crown', coin: 'less-spent-icon', color: 'text-400' };
    }
    if (this.isDefaultDate(clientSince)) {
      return { crown: 'default', coin: 'default', color: '' };
    }
    const duration = timeLineService(this.timeService.ConvertUTCToLocalDateTime(clientSince));
    if (
      duration.timeline == 'year' &&
      duration.value >= 1 &&
      duration.value < 3 &&
      duration.type == 'ago'
    ) {
      return { crown: 'bronze-crown', coin: 'medium-spent-icon', color: 'text-800' };
    } else if (
      duration.timeline == 'year' &&
      duration.value >= 3 &&
      duration.value < 5 &&
      duration.type == 'ago'
    ) {
      return { crown: 'silver-crown', coin: 'less-spent-icon', color: 'text-400' };
    } else if (
      duration.timeline == 'year' &&
      duration.value >= 5 &&
      duration.type == 'ago'
    ) {
      return { crown: 'gold-crown', coin: 'most-spent-icon', color: 'text-yellow-600' };
    } else {
      return { crown: 'default', coin: 'default', color: '' };
    }
  }

  get showSkeleton(): boolean {
    return this.showSkeleton$.getValue();
  }

  get clientDetailsObj(): BehaviorSubject<ClientById> {
    return new BehaviorSubject<ClientById>(this.client);
  }

  changeInAction(e: any) {
    this.getClientDetails();
  }


  ActiveTenant(client: any) {
    if(client.client_status == ClientStatus.Prospect || client.client_status.toString() == ClientStatus[ClientStatus.Prospect])
    {
      return this.allTenants.find((o: { id: number; }) => o.id == client.latest_createdin_tenant_id)!;
    }
    else{
      if (client.home_club_tenant_id && client.home_club_tenant_id > 0)
        return this.allTenants.find((o: { id: number; }) => o.id == client.home_club_tenant_id)!;
      else return this.allTenants.find((o: { id: number; }) => o.id == client.latest_createdin_tenant_id)!;
    }
    // if (client.home_club_tenant_id && client.home_club_tenant_id > 0)
    //   return this.allTenants.find((o: { id: number; }) => o.id == client.home_club_tenant_id)!;
    // else return this.allTenants.find((o: { id: number; }) => o.id == client.latest_createdin_tenant_id)!;
  }

  getSalesRep(staffId: number) {
    return this.staffStoreService.getStaffById(staffId).pipe(map((staff) => {
      return staff;
    }));
  }

  GetReffferedBy(staffId: number) {
    //return this.allStaffs.find((o: { id: number; }) => o.id == staffId)! ? this.allStaffs.find((o: { id: number; }) => o.id == staffId) : null;
    return this.staffStoreService.getStaffById(staffId).pipe(map((staff) => {
      return staff;
    }));
  }

  getLanguage(code: string) {
    return CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === code)) ? CONSTANTS_DATA.ALL_LANGUAGES.find((lang) => (lang.LANG_CODE === code))?.LANG_ABBRE : '';
  }

  toggleSendEmailDialog() {
    this.toggleSendEmailDialog$.next(true);
  }

  closeSendEmailDialog(event: any) {
    this.toggleSendEmailDialog$.next(false);
    if (event && event.action && event.action == 'updated') this.getClientDetails();
  }

  toggleCreateSmsDialog() {
    this.toggleCreateSmsDialog$.next(true);
  }

  closeCreateSmsDialog(event: any) {
    this.toggleCreateSmsDialog$.next(false);
    if (event && event.action && event.action == 'updated') this.getClientDetails();
  }

  toggleChangeSaleRepDialog() {
    this.toggleChangeSaleRepDialog$.next(true);
  }

  closeChangeSaleRepDialog(event: any) {
    this.toggleChangeSaleRepDialog$.next(false);
    if (event && event.action && event.action == 'updated'){
      setTimeout(() => {
        this.getClientDetails();
        this.cd.detectChanges();
      }, 500);
    }
  }


  showCreditBalancePopup()
  {
    if(this.showAddCreditButton)
      this.showCreditBalance= true;
    else this.showCreditBalance= false;
  }

  get isClientBlackListed() {
    return this.client && this.client.is_blacklisted;
  }

  get clientDetails(): BehaviorSubject<ClientById> {
    return new BehaviorSubject<ClientById>(this.client);
  }

  get NewRepresentative(): UntypedFormControl {
    return this.updateClientFormGroup.get('NewRepresentative') as UntypedFormControl;
  }


  CloseBookAppointment(event: any) {
    this.showBookAppointmentPopup = event;
  }

  viewWaiver()
  {
    this.attachmentsModal = true;
  }

  closeAttachmentDialog(event:any){
    this.attachmentsModal=false;
  }

  reloadEvents(event: any) {
  }

  closeCreditPopup(event:any)
  {
    this.showCreditBalance=false;
    if (event && event.action && event.action == 'updated') this.getClientDetails();
  }

  getLastCenter(tenantId: number) {
    return this.allTenants.find((o: { id: number; }) => o.id == tenantId)!;
  }

  updateField(fieldName: string, value: any) {
    let clientObj: Array<{ op: string, path: string, value: any }> = [];
    let successMessageKey = '';
    
    switch(fieldName) {
      case 'mobile_number':
        clientObj.push({ op: "replace", path: "/MobileNumber", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.MOBILE_UPDATED';
        break;
      case 'email_id':
        clientObj.push({ op: "replace", path: "/EmailId", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.EMAIL_UPDATED';
        break;
      case 'date_of_birth':
        clientObj.push({ op: "replace", path: "/DateOfBirth", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.DOB_UPDATED';
        break;
      case 'emergency_contact_person':
      case 'emergency_contact_number':
        clientObj.push({ op: "replace", path: "/EmergencyContactPerson", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.EMERGENCY_CONTACT_UPDATED';
        break;
      case 'gender':
        clientObj.push({ op: "replace", path: "/Gender", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.GENDER_UPDATED';
        break;
      case 'channel':
        clientObj.push({ op: "replace", path: "/Channel", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.CHANNEL_UPDATED';
        break;
      case 'source':
        clientObj.push({ op: "replace", path: "/Source", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.SOURCE_UPDATED';
        break;
      case 'address':
        clientObj.push({ op: "replace", path: "/Address", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.ADDRESS_UPDATED';
        break;
      case 'client_representative_id':
        clientObj.push({ op: "replace", path: "/ClientRepresentativeId", value: value });
        successMessageKey = 'CLIENT_PROFILE.SUCCESS_MESSAGES.SALES_REP_UPDATED';
        break;
    }

    this.clientService.patchClient(this.client.id, this.tenantId, clientObj).subscribe({
      next: (response) => {
        if (fieldName in this.client) {
          if(fieldName == 'mobile_number') {
            var mobileObj = this.updateClientFormGroup.get('mobile_number')?.value;
            this.client.mobile_number =mobileObj.number.replace(/[\s\-\(\)]/g, '');
            this.client.mobile_country_code = mobileObj.dialCode;
            this.updateClientFormGroup.get('mobile_number')?.setValue(this.client.mobile_number);
            this.clientMobileNoCountry = mobileObj.countryCode;
          }
          else {
            (this.client as any)[fieldName] = value;
          }

        }
        this.toastMessageService.showSuccess(this.translate.instant(successMessageKey));
        this.resetEditMode(fieldName);
        this.cd.detectChanges();

      },
      error: (error) => {
        console.error(`Error updating ${fieldName}:`, error);
        this.toastMessageService.showError(error);
        if (fieldName in this.client) {
          const originalValue = (this.client as any)[fieldName];
          this.updateClientFormGroup.patchValue({ [fieldName]: originalValue });
        }
        this.resetEditMode(fieldName);
        this.cd.detectChanges();
      }
    });
  }

  resetEditMode(fieldName: string) {
    switch(fieldName) {
      case 'mobile_number':
        this.changeMobile = false;
        break;
      case 'email_id':
        this.changeEmail = false;
        break;
      case 'date_of_birth':
        this.changeDOB = false;
        break;
      case 'emergency_contact_person':
      case 'emergency_contact_number':
        this.changeEmergencyContact = false;
        break;
      case 'gender':
        this.changeGender = false;
        break;
      case 'channel':
        this.changeChannel = false;
        break;
      case 'source':
        this.changeSource = false;
        break;
      case 'address':
        this.changeAddress = false;
        break;
      case 'client_representative_id':
        this.changeSalesRep = false;
        break;
    }
  }

  // Individual field update handlers
  onMobileNumberUpdate() {
    const value = this.updateClientFormGroup.get('mobile_number')?.value ? this.updateClientFormGroup.get('mobile_number')?.value.number.replace(/[\s\-\(\)]/g, '') : 0;
    this.updateField('mobile_number', value);
  }

  onEmailUpdate() {
    const value = this.updateClientFormGroup.get('email_id')?.value;
    this.updateField('email_id', value);
  }

  onDOBUpdate() {
    const value = this.updateClientFormGroup.get('date_of_birth')?.value;
    this.updateField('date_of_birth', value);
  }

  onEmergencyContactUpdate() {
    const person = this.updateClientFormGroup.get('emergency_contact_person')?.value;
    const number = this.updateClientFormGroup.get('emergency_contact_number')?.value ? this.updateClientFormGroup.get('emergency_contact_number')?.value.e164Number : 0;
    
    let clientObj: Array<{ op: string, path: string, value: any }> = [
      { op: "replace", path: "/EmergencyContactPerson", value: person },
      { op: "replace", path: "/EmergencyContactNumber", value: number }
    ];

    this.clientService.patchClient(this.client.id, this.tenantId, clientObj).subscribe({
      next: (response) => {
        this.client.emergency_contact_person = person;
        this.client.emergency_contact_number = number;
        this.changeEmergencyContact = false;
        this.cd.detectChanges();
      },
      error: (error) => {
        this.updateClientFormGroup.patchValue({
          emergency_contact_person: this.client.emergency_contact_person,
          emergency_contact_number: this.client.emergency_contact_number
        });
        this.toastMessageService.showError(error);
        this.cd.detectChanges();
      }
    });
  }

  onGenderUpdate() {
    const value = this.updateClientFormGroup.get('gender')?.value;
    this.updateField('gender', value.value);
  }

  onChannelUpdate() {
    const value = this.updateClientFormGroup.get('channel')?.value;
    this.Source = value.source;
    this.updateField('channel', value.channel);
  }

  onSourceUpdate() {
    const value = this.updateClientFormGroup.get('source')?.value;
    this.updateField('source', value);
  }

  onAddressUpdate() {
    const value = this.updateClientFormGroup.get('address')?.value;
    this.updateField('address', value);
  }

  onSalesRepUpdate() {
    const value = this.updateClientFormGroup.get('salesRep')?.value;
    this.updateField('salesRep', value);
  }

  // Helper method to handle enter key press
  onEnterKeyPress(event: KeyboardEvent, fieldName: string) {
    if (event.key === 'Enter') {
      event.preventDefault();
      switch(fieldName) {
        case 'mobile_number':
          this.onMobileNumberUpdate();
          break;
        case 'email_id':
          this.onEmailUpdate();
          break;
        case 'address':
          this.onAddressUpdate();
          break;
        // Add other cases as needed
      }
    }
  }

  private getParsedNumber(phoneNumber: string, countryCode: string): number {
    let number: lpn.PhoneNumber = '' as unknown as lpn.PhoneNumber;
    let num: number = 0;
    try {
      number = this.phoneUtil.parse(phoneNumber, countryCode.toUpperCase());
      num = this.phoneUtil.format(number, lpn.PhoneNumberFormat.NATIONAL);
    } catch (e) { }
    return num;

  }

  toggleClientHistory() {
    this.showClientHistory = !this.showClientHistory;
    this.cd.detectChanges();
  }

  closeClientHistoryDialog(event: any) {
    this.showClientHistory = false;
    this.cd.detectChanges();
  }
}